import { JiraApiClient } from './JiraApiClient';
import JiraApiService from './JiraApiService';

const jiraApiClient = new JiraApiClient();
export const JiraService = new JiraApiService(jiraApiClient);
